module.exports = __webpack_public_path__ + "img/gradient-card.4c042c0c.svg";